module.exports = __webpack_public_path__ + "static/media/apple.dd03279d.png";